import React, { useCallback, useMemo, useState } from 'react';
import { Footer } from './components/Footer';
import { GameScreen } from './components/GameScreen';
import { HomeScreen } from './components/HomeScreen';
import { InfoModal } from './components/InfoModal';
import { SponsorModal } from './components/SponsorModal';
import { TopBar } from './components/TopBar';
import type { GameMode } from './game/types';
import { getHighScore } from './utils/storage';

export default function App() {
  const [view, setView] = useState<'home' | 'game'>('home');
  const [mode, setMode] = useState<GameMode>('normal');
  const [sponsorOpen, setSponsorOpen] = useState(false);
  const [info, setInfo] = useState<'daily' | 'upgrade' | 'leaderboard' | null>(null);
  const [toast, setToast] = useState<string | null>(null);
  const highScore = useMemo(() => getHighScore(), [view, info]);

  const showToast = useCallback((message: string) => {
    setToast(message);
    window.setTimeout(() => setToast((current) => current === message ? null : current), 2300);
  }, []);

  const startGame = (selectedMode: GameMode) => {
    setMode(selectedMode);
    setView('game');
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const goHome = () => {
    setView('home');
    setInfo(null);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="app-shell">
      <TopBar view={view} onHome={goHome} onSponsor={() => setSponsorOpen(true)} />
      <div className="main-content">
        {view === 'home'
          ? <HomeScreen onStart={startGame} onOpenInfo={setInfo} highScore={highScore} />
          : <GameScreen mode={mode} onHome={goHome} onToast={showToast} />}
      </div>
      <Footer />
      {sponsorOpen && <SponsorModal onClose={() => setSponsorOpen(false)} />}
      {info && <InfoModal type={info} onClose={() => setInfo(null)} />}
      {toast && <div className="toast" role="status">{toast}</div>}
    </div>
  );
}
